<template>
<div class="ui segments">

  <div class="ui segment">
    <div class="ui breadcrumb">
      <router-link :to="{name:'home'}" class="section">Sākums</router-link>
      <span class="divider">/</span>
      <div class="active section">Ikmēneša rēķini</div>
    </div>
  </div>

  <div class="ui segment" v-bind:class="{ loading: storeStatus.loading }">
    <table class="ui selectable table orange">
      <thead v-if="!checkClientWidth">
        <tr>
          <th>Datums</th>
          <th>Pavadzīmes Nr.</th>
          <th>Kopsumma</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in items">
          <td>{{item.created_at}}</td>
          <td>{{item.ramus_id}}</td>
          <td>{{(item.amount*(-1)).toFixed(2)}} &euro;</td>
          <td><a v-if="item.ramus_id != '' " v-on:click="getPdf(item.id)" class="ms-pointer"><i class="file pdf outline icon"></i>Lejupielādēt pavadzīmi</a></td>
        </tr>
      </tbody>
      <paginator :paginator="paginator" link-name="user-monthly-bills-page"></paginator>
    </table>

  </div>

</div>
</template>

<script>
import Paginator from './Paginator'

export default {
  components: {
    Paginator
  },
  data() {
    return {
      isactive: false
    }
  },

  computed: {
    items() {
      return this.$store.state.transactionStore.items
    },
    storeStatus() {
      return this.$store.state.transactionStore.status
    },
    paginator() {
      return this.$store.state.transactionStore.transactionExtraData
    },
    checkClientWidth(){
     return document.documentElement.clientWidth < 768
   },
  },

  created: function() {
    this.isactive = true; //used to ensure that when route keeps changing we dont reload data while component is not visible
    //preload data
    this.loadTransactions();

  },
  activated: function() {
    this.isactive = true; //used to ensure that when route keeps changing we dont reload data while component is not visible
    //preload data

  },
  deactivated: function() {
    this.isactive = false;
  },

  watch: {
    '$route': 'loadTransactions'
  },

  methods: {
    getPdf: function(trxId) {
      this.$store.dispatch('getTransactionPdfUrl', trxId).then((response) => {
        window.location = response.data.url
      }).catch((error) => {
        console.error('error during pdf creation. OrderId: ' + trxId)
      });
    },

    loadTransactions: function() {
      //as this is called by watcher then first check if component is activated
      if (this.isactive) this.$store.dispatch('loadTransactionStore', [this.$route.params.page, 4]);
    }
  }
}
</script>

<style>
.ms-pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// UserMonthlyBillsPage.vue?268e2524